import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { API } from "@/lib/api";

export default function AuthCallback() {
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { nav("/admin/login"); return; }
    axios
      .post(`${API}/admin/google-session`, {}, { headers: { "X-Session-ID": sid }, withCredentials: true })
      .then((r) => {
        localStorage.setItem("admin_token", r.data.token);
        window.history.replaceState({}, "", "/admin");
        toast.success(`Welcome, ${r.data.name || "admin"}.`);
        nav("/admin");
      })
      .catch((e) => {
        toast.error(e.response?.data?.detail || "Google sign-in failed.");
        nav("/admin/login");
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1A1514] text-[#F9F8F6]" data-testid="auth-callback">
      <p className="text-sm tracking-wide">Signing you in…</p>
    </div>
  );
}
